import React from "react";
import { Navigate } from "react-router-dom";
import PublicLayout from "../layouts/public/Public";

const isLoggedIn = localStorage.getItem("token");

const PublicRoute = (props) => (!isLoggedIn ? <PublicLayout {...props} /> : <Navigate to="/dashboard" />);

export default PublicRoute;
